import React, { useCallback } from 'react';
import styled from 'styled-components';
import { DEFAULT_THEME_COLOR } from 'appenv';
import DrawerListItem from 'components/appbar/mobile/DrawerListItem';
import { RemappedSecondaryPage } from 'models/types/appBar';
import { useSelector } from 'react-redux';
import SecondaryNavTitle from 'components/appbar/mobile/SecondaryNavTitle';
import SecondaryNavLink from 'components/appbar/mobile/SecondaryNavLink';
import SecondaryNavList from 'components/appbar/mobile/SecondaryNavList';
import SecondaryNavItem from 'components/appbar/mobile/SecondaryNavItem';
import { matchPath } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

const DrawerContainer = styled.div`
  flex: 1;
  padding: 8px 16px 0 8px;
`;

const DrawerNestedLinks = ({ title, subLinks = [] }: {
  title: string;
  // eslint-disable-next-line react/require-default-props
  subLinks?: RemappedSecondaryPage[];
}) => {
  const {
    themeColor,
  } = useSelector((state) => state.eventConfigs);

  const activeLinkStyle = {
    color: themeColor || DEFAULT_THEME_COLOR,
  };

  const isActive = useCallback((_: any, location: Location) => {
    const flattened: Record<string, boolean> = subLinks.reduce((acc, subLink) => {
      acc[subLink.to] = true;
      return acc;
    }, {});
    return location.pathname in flattened;
  }, [subLinks]);

  return (
    <DrawerListItem button={false as true}>
      <DrawerContainer>
        <SecondaryNavTitle
          activeStyle={activeLinkStyle}
          isActive={isActive}
        >
          <div>{ReactHtmlParser(title)}</div>
        </SecondaryNavTitle>
        <SecondaryNavList>
          {subLinks.map((link) => {
            if (link.newTab) {
              return (
                <SecondaryNavItem button key={link.name} onClick={link.onClick}>
                  <SecondaryNavLink
                    as="a"
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {ReactHtmlParser(link.name)}
                  </SecondaryNavLink>
                </SecondaryNavItem>
              );
            }
            return (
              <SecondaryNavItem button key={link.name} onClick={link.onClick}>
                <SecondaryNavLink
                  to={link.to}
                  activeStyle={activeLinkStyle}
                  isActive={(match, location) => !!(
                    matchPath(location.pathname, {
                      path: [link.to],
                      exact: true,
                    })
                  )}
                >
                  {ReactHtmlParser(link.name)}
                </SecondaryNavLink>
              </SecondaryNavItem>
            );
          })}
        </SecondaryNavList>
      </DrawerContainer>
    </DrawerListItem>
  );
};

export default DrawerNestedLinks;
